import { lazyLoad } from '../../../../shared/utils/loadable';

export const PasswordResetEditCompletePage = lazyLoad(
  () => import('./index'),
  (module) => module.PasswordResetEditComplete,
);
